import { Currency as CurrencyKit } from "@bentolabs/kit/entities";
import { AppKitNetwork } from "@reown/appkit/networks";
import { Address } from "viem";
import { mainnet } from "viem/chains";

import {
  bentoUSDAddresses,
  bentoUSDPlusAddresses,
  tellerAddresses,
} from "./addresses";

export type Currency = CurrencyKit;

export const bentoBirthDay = new Date("2025-03-20T12:00");

export const blockchainProvider: "wagmi" | "appkit" =
  import.meta.env.VITE_WALLET ?? "appkit";

const layer = import.meta.env.VITE_LAYER;

export const mainnetChain: AppKitNetwork = {
  ...mainnet,
  rpcUrls: {
    default: {
      http: [
        "https://virtual.mainnet.eu.rpc.tenderly.co/515bd3d0-634d-4a03-8091-88e7afa5eea9",
      ],
      webSocket: [
        "wss://virtual.mainnet.eu.rpc.tenderly.co/6f7a485d-1619-436d-85d6-f39d8c6e4a91",
      ],
    },
  },
};

export const chainLinkAggregatorConfig: Record<
  number,
  Record<string, Address>
> = {
  [mainnetChain.id]: {
    ETH: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419" as Address,
    USDT: "0x3E7d1eAB13ad0104d2750B8863b489D65364e32D" as Address,
    USDC: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6" as Address,
    USDe: "0xa569d910839Ae8865Da8F8e70FfFb0cBA869F961" as Address,
    USDS: "0xfF30586cD0F29eD462364C7e81375FC0C71219b1" as Address,
  },
};

export const bentoUSDConfig: Record<number, Currency> = {
  [mainnetChain.id]: {
    chainId: mainnetChain.id,
    address: bentoUSDAddresses[layer],
    name: "bentoUSD",
    symbol: "bentoUSD",
    decimals: 18,
    logoURI: "/bento-usd-token.svg",
  },
};

export const bentoUSDPlusConfig: Record<number, Currency> = {
  [mainnetChain.id]: {
    chainId: mainnetChain.id,
    address: bentoUSDPlusAddresses[layer] as Address,
    name: "bentoUSDPlus",
    symbol: "bentoUSD+",
    decimals: 18,
    logoURI: "/bento-usd-plus-token.svg",
  },
};

export const tellerConfig: Record<number, Address> = {
  [mainnetChain.id]: tellerAddresses[layer],
};

export const oneInchAggregationRouterV6Config: Record<number, Address> = {
  [mainnetChain.id]: "0x111111125421cA6dc452d289314280a0f8842A65" as Address,
};
